import React from 'react';

import { Skeleton } from '../../../components/skeleton/skeleton';
import { currencyFormatter } from '../../../lib/utils/currency-formatter';
import { PreviewAddMemberUpdatesResponse } from '../../billing/store/billing.slice';

import styles from './payment-preview.module.scss';
interface PaymentPreviewProps {
  isLoading: boolean;
  paymentDetails?: PreviewAddMemberUpdatesResponse | null;
}

export const PaymentPreview: React.FC<PaymentPreviewProps> = ({ paymentDetails, isLoading }) => {
  const { currentPayment, nextPayment } = paymentDetails || {};
  const { amount: currentAmount, currency: currentCurrency } = currentPayment || {};
  const { date: nextPaymentDate, amount: nextPaymentAmount, currency } = nextPayment || {};

  return (
    <div className={styles['payment-details-section']}>
      <div className={styles['payment-details-row']}>
        <p className={styles['payment-details-title']}>Total to be charged now</p>

        {isLoading ? (
          <Skeleton width={4} height={1.4} />
        ) : (
          <p>
            {paymentDetails &&
              currencyFormatter(parseFloat(currentAmount || '0'), currentCurrency || currency!)}
          </p>
        )}
      </div>

      <div className={styles['payment-details-row']}>
        <p className={styles['payment-details-title']}>
          Total to be charged on{' '}
          {nextPaymentDate ? (
            <span className={styles['payment-date']}>{nextPaymentDate}</span>
          ) : (
            <Skeleton width={8} height={1.4} />
          )}
        </p>

        {isLoading ? (
          <Skeleton width={4} height={1.4} />
        ) : (
          <p>
            {paymentDetails && currencyFormatter(parseFloat(nextPaymentAmount || '0'), currency!)}
          </p>
        )}
      </div>
    </div>
  );
};
